export enum ActionType {
  ADD_TOKEN = "ADD_TOKEN",
  REMOVE_TOKEN = "REMOVE_TOKEN",
  L1_TRANSACTION = "L1_TRANSACTION",
  L2_TRANSACTION = "L2_TRANSACTION",
  CHANGE_VALIDATOR_SET = "CHANGE_VALIDATOR_SET",
}
